import { capitalizeAndRemoveUnderscores } from './../../common/utils/src/lib/text.utils';
import { LotAppointmentStatus } from './../data-access/src/lib/generated/generated';

export const LotAppointmentDropdownOptions = [
  {
    text: capitalizeAndRemoveUnderscores(LotAppointmentStatus.Cancelled),
    value: LotAppointmentStatus.Cancelled
  },
  {
    text: capitalizeAndRemoveUnderscores(LotAppointmentStatus.Confirmed),
    value: LotAppointmentStatus.Confirmed
  },
  {
    text: capitalizeAndRemoveUnderscores(LotAppointmentStatus.Held),
    value: LotAppointmentStatus.Held
  },
  {
    text: capitalizeAndRemoveUnderscores(LotAppointmentStatus.NoShow),
    value: LotAppointmentStatus.NoShow
  },
  {
    text: capitalizeAndRemoveUnderscores(LotAppointmentStatus.Pending),
    value: LotAppointmentStatus.Pending
  },
  {
    text: capitalizeAndRemoveUnderscores(LotAppointmentStatus.Rescheduled),
    value: LotAppointmentStatus.Rescheduled
  }
];

export const CREATE_EVENT_MODAL_CONFIG = {
  firstTitleKey: 'Where do you want to add an Event?',
  secondTitleKey: 'Add Event for a Homeowner',
  primaryButtonKey: 'Add Default Event',
  secondaryButtonKey: 'Add Event for a Homeowner',
  createButtonKey: 'Continue Adding Event',
  routerLinkKey: 'schedule'
};
